<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
    :footer="false"
  >
    <form class="t-walkthrough-routing-user-group__form">
      <div class="t-walkthrough-routing-user-group__description">
        <a-heading tag="h3" size="small">1. フロー設定</a-heading>
        <a-text>それぞれの番号の対応内容を設定してください</a-text>
      </div>
      <div class="t-walkthrough-routing-user-group__fields">
        <o-response-flow-setting-list
          v-model="currentSettingList"
          :voice-d-x-phone-number-list="voiceDXPhoneNumberList"
          @config="handleFlowConfig"
        />
      </div>
      <div class="t-walkthrough-routing-user-group__remark">
        <a-caption-list>
          <li>1-5の番号のみ設定できます</li>
          <li>この番号以外を押すと、ガイダンスがリピート再生されます</li>
        </a-caption-list>
      </div>
      <div class="t-walkthrough-routing-user-group__buttons">
        <m-button-container>
          <a-button variant="block" color="primary" @click="handleSubmitForm">次へ</a-button>
          <a-button variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
          <a-button
            color="primary"
            class="t-walkthrough-routing-user-group__button-optional"
            @click="handleNotSettingClick"
            >初期設定はせずにホーム画面へ</a-button
          >
        </m-button-container>
      </div>
      <teleport to="body">
        <o-modal
          id="walkthroughRouting_settingModal"
          v-model:visible="settingDialogVisible"
          class="o-modal-flow-setting"
          footer-variant="dialog"
          width="568px"
          title-icon="phone-incoming-call"
          title-icon-color="orange"
          :title="settingModalTitle"
          :footer-shadow="true"
          :close-on-click-modal="false"
        >
          <m-form-input label="設定名称">
            <a-text-field v-model="formData.name" type="text" placeholder="営業問合せ" />
          </m-form-input>
          <m-form-input label="対応方法">
            <a-select-field
              v-if="isDataLoaded"
              id="responseOptions"
              v-model="formData.response_mode"
              :options="responseOptions"
            />
          </m-form-input>
          <m-form-input v-if="formData.response_mode === null" label="" class="mb-32"> </m-form-input>
          <m-form-input v-if="formData.response_mode === null" label="" class="mb-32"> </m-form-input>
          <!--          <template v-if="formData.response_mode === 'user'">-->
          <!--            <m-form-input label="着信グループ名">-->
          <!--              <a-text-field v-model="formData.group_name" type="text" placeholder="営業問合せ" />-->
          <!--            </m-form-input>-->
          <!--            <m-form-input>-->
          <!--              <m-user-selection-table v-model="formData.users" :user-list="userList" :compact="true" />-->
          <!--            </m-form-input>-->
          <!--          </template>-->
          <m-form-input v-if="formData.response_mode === 'user'" label="着信グループ名" class="mb-32">
            <a-select-field
              id="userGroupOptions"
              v-model="formData.group_name"
              :options="userGroupOptions"
              class="mb-32"
            />
          </m-form-input>
          <!--Make white space to show pull down-->
          <m-form-input v-if="formData.response_mode === 'user'" label="" class="mb-32"> </m-form-input>
          <m-form-input v-if="formData.response_mode === 'transfer'" label="電話番号">
            <a-text-field v-model="formData.phone_number" type="tel" placeholder="0312345678" maxlength="11" />
          </m-form-input>
          <m-form-input v-if="formData.response_mode === 'voiceDX'" label="COTOHA Voice DX Basic番号名称" class="mb-32">
            <a-select-field
              id="voiceDXPhoneNumberList"
              v-model="formData.phone_number"
              :options="voiceDXPhoneNumberList"
              class="mb-32"
            />
          </m-form-input>
          <m-form-input v-if="formData.response_mode === 'voiceDX'" label="" class="mb-32"> </m-form-input>
          <template #footer>
            <a-button variant="outlined" color="primary" label="戻る" size="small" @click="handleCancelDialog" />
            <a-button variant="block" color="primary" label="設定を反映" size="small" @click="handleSubmitDialog" />
          </template>
        </o-modal>
      </teleport>
      <teleport to="body">
        <o-modal
          id="walkthroughRouting_resultModal"
          v-model:visible="resultModalVisible"
          class="o-modal-remove-phone-number-confirmation"
          footer-variant="confirmation"
          width="442px"
          :footer-shadow="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
          <template #title>{{ resultModalTitle }}</template>
          <a-text>
            <!-- eslint-disable -->
            <span v-html="resultModalContent" />
            <!-- eslint-enable -->
          </a-text>
          <template #footer>
            <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
          </template>
        </o-modal>
      </teleport>
    </form>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AHeading from '@/components/atoms/heading';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import OResponseFlowSettingList from '@/components/organisms/response-flow-setting-list';
import ACaptionList from '@/components/atoms/caption-list';
import AText from '@/components/atoms/text';
import OModal from '@/components/organisms/modal';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import ASelectField from '@/components/atoms/select-field';
// import MUserSelectionTable from '@/components/molecules/user-selection-table';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';

export default {
  name: 't-walkthrough-routing-user-group',
  components: {
    TDefaultEntrySidebar,
    AHeading,
    AButton,
    MButtonContainer,
    OResponseFlowSettingList,
    ACaptionList,
    AText,
    OModal,
    MFormInput,
    ATextField,
    ASelectField,
    // MUserSelectionTable,
  },
  mixins: [customRequest, messageContent, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // settingList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // responseOptions: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // userList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // handleFormSubmit: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNotSettingClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      isDataLoaded: false,
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      currentSettingList: [],
      settingDialogVisible: false,
      formData: {
        index: -1,
        name: '',
        response_mode: 'user',
        group_name: null,
        users: [],
        phone_number: '',
      },
      sidebarInfo: {
        sidebarList: [
          { label: 'ユーザー招待' },
          {
            label: '営業時間設定',
            subStepLabel: '営業時間設定する場合',
            steps: ['営業時間設定', '対応方法設定'],
          },
          {
            label: '着信フローの設定',
            subStepLabel: '分岐を設定する場合',
            steps: ['フロー設定', '自動音声ガイダンス設定'],
            currentStep: 1,
          },
        ],
        sidebarCurrent: 3,
        heading: '着信フローの設定',
        subHeading: 'Step 3',
        sidebarSubHeading: 'Walk Through',
        sidebarHeading: '初期設定',
      },
      settingList: [
        {
          active: false,
          responseMode: null,
          settingName: '',
          value: '',
          users: [],
        },
        {
          active: false,
          responseMode: null,
          settingName: '',
          value: '',
          users: [],
        },
        {
          active: false,
          responseMode: null,
          settingName: '',
          value: '',
          users: [],
        },
        {
          active: false,
          responseMode: null,
          settingName: '',
          value: '',
          users: [],
        },
        {
          active: false,
          responseMode: null,
          settingName: '',
          value: '',
          users: [],
        },
      ],
      guidance: '',
      responseOptions: [
        {
          label: '指定ユーザーが着信',
          value: 'user',
        },
        {
          label: '外線転送',
          value: 'transfer',
        },
      ],
      voiceDXPhoneNumberList: [],
      userList: [],
      userGroupOptions: [],
      phone_number: this.$store.state.user.phoneNumber ? this.$store.state.user.phoneNumber : '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-routing-user-group');
      return `${baseClassName} ${this.class}`.trim();
    },
    settingModalTitle() {
      if (this.formData.index !== -1) {
        const index = this.formData.index || 0;
        return `プッシュ番号${index + 1}`;
      }
      return '';
    },
  },
  watch: {
    settingList(val) {
      this.currentSettingList = this.settingList;
    },
  },
  mounted() {
    if (this.$route.params.formData) {
      this.preloadData(true);
      this.currentSettingList = JSON.parse(String(this.$route.params.formData));
      this.guidance = this.$route.params.guidance;
    } else if (this.settingList) {
      // this.currentSettingList = this.settingList;
      this.preloadData();
    }
    // this.preloadData();
  },
  methods: {
    // loadUsers() {
    //   this.postRequest('/walkthrough/user-list', {
    //     companyID: this.companyID,
    //   })
    //     .then(res => {
    //       this.userList = res.data;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       this.showErrorModal('検索中にエラーが発生しました。時間を空けて再度実行してください。');
    //     });
    // },
    preloadData(handleCancelClick = false) {
      this.postRequest('/walkthrough/routing-user-group-preload-data', {
        companyID: this.companyID,
      })
        .then(res => {
          this.userGroupOptions = res.data.userGroupOptions;
          this.voiceDXPhoneNumberList = res.data.voiceDXPhoneNumberList;
          if (res.data.isIVR) {
            if (handleCancelClick === false) {
              this.settingList = res.data.flows;
              this.guidance = res.data.guidance;
            }
          }
          if (this.voiceDXPhoneNumberList.length !== 0) {
            this.responseOptions = [
              {
                label: '指定ユーザーが着信',
                value: 'user',
              },
              {
                label: '外線転送',
                value: 'transfer',
              },
              {
                label: 'COTOHA Voice DX Basic',
                value: 'voiceDX',
              },
            ];
          }
          this.isDataLoaded = true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    validateFlow(flow) {
      if (flow.active && flow.settingName && flow.responseMode && flow.value) {
        return 'complete';
      }
      if (flow.active && (!flow.settingName || !flow.responseMode || flow.value)) {
        return 'incomplete';
      }
      return 'unset';
    },
    handleSubmitForm(e) {
      e.preventDefault();
      const payload = cloneDeep(this.currentSettingList);
      // Validate flows
      let count = 0;
      for (const i in payload) {
        const flow = payload[i];
        const result = this.validateFlow(flow);
        if (result === 'complete') {
          count++;
        } else if (result === 'incomplete') {
          const n = parseInt(i) + 1;
          this.showErrorModal(messageContent.requirePushNumberX(String(n)));
          return false;
        }
      }
      if (count === 0) {
        this.showErrorModal(messageContent.requirePushNumber);
        return false;
      }
      return this.handleFormSubmit(payload);
    },
    handleFlowConfig(index) {
      if (this.currentSettingList[index]) {
        const flow = this.currentSettingList[index];
        this.formData.index = index;
        this.formData.name = flow.settingName;
        this.formData.response_mode = flow.responseMode ? flow.responseMode : null;
        this.formData.group_name = flow.groupName ? flow.groupName : null;
        this.formData.phone_number = flow.transferNumber ? flow.transferNumber : '';
        this.settingDialogVisible = true;
      }
    },
    clearFormData() {
      this.formData.index = -1;
      this.formData.name = '';
      this.formData.response_mode = 'user';
      this.formData.group_name = null;
      // this.formData.users = [];
      this.formData.phone_number = '';
    },
    handleCancelDialog() {
      this.settingDialogVisible = false;
      this.clearFormData();
    },
    handleSubmitDialog() {
      const formData = cloneDeep(this.formData);
      if (!this.validateForm(formData)) {
        return;
      }
      if (formData.index !== -1) {
        if (this.currentSettingList[formData.index]) {
          const flow = this.currentSettingList[formData.index];
          flow.responseMode = formData.response_mode;
          flow.settingName = formData.name;
          if (formData.response_mode === 'user') {
            flow.value = formData.group_name;
            flow.groupName = flow.value;
            // flow.users = formData.users;
            this.settingDialogVisible = false;
          } else {
            if (formData.phone_number !== this.phone_number) {
              flow.value = formData.phone_number;
              flow.transferNumber = flow.value;
              this.settingDialogVisible = false;
              this.clearFormData();
            } else {
              this.showErrorModal(messageContent.notSetTransferNumber);
            }
          }
        }
      }
    },
    validateForm(formData) {
      // Validate special characters
      if (this.hasSpecialCharacterInObject(formData)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return false;
      }
      // Validate setting name
      if (!formData.name) {
        this.showErrorModal(messageContent.requireInput('設定名称'));
        return false;
      }
      // Only space check
      const onlySpaceChk = this.onlySpaceCheck(formData.name, '設定名称');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return false;
      }
      const lengthCheck = this.settingNameLengthCheck(formData.name);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return false;
      }
      // Validate response_mode
      if (!formData.response_mode) {
        this.showErrorModal(messageContent.requireChoice('対応方法'));
        return false;
      }
      if (formData.response_mode === 'user') {
        // Validate group_name
        if (!formData.group_name) {
          this.showErrorModal(messageContent.requireInput('着信グループ名'));
          return false;
        }
        // Validate users
        // if (formData.users.length === 0) {
        //   this.showErrorModal('ユーザーを選択してください。');
        //   return false;
        // }
        // if (formData.users.length > 10) {
        //   this.showErrorModal('一斉着信は最大10名まで指定してください。');
        //   return false;
        // }
      } else if (formData.response_mode === 'transfer') {
        // Validate phone number
        if (!this.numberOnly(formData.phone_number)) {
          this.showErrorModal(messageContent.phonenumberIsNotHalfWidth);
          return false;
        }
        if (formData.phone_number.length !== 11 && formData.phone_number.length !== 10) {
          this.showErrorModal(messageContent.invalidDigitsNumberOfPhoneNumber);
          return false;
        }
      } else {
        if (!this.voiceDXPhoneNumberList.some(v => v.value === formData.phone_number)) {
          this.showErrorModal(messageContent.requirePhonenumberOfVDXB);
          return false;
        }
      }
      return true;
    },
    handleFormSubmit(formData) {
      //console.log('着信フローの設定');
      // console.log(formData);
      // Go to guidance page with form data
      this.$router.push({
        name: 'WTIvrGuidance',
        params: { formData: JSON.stringify(formData), guidance: this.guidance },
      });
    },
    handleCancelClick() {
      this.$router.push({ name: 'WTSelectIvr' });
    },
    handleNotSettingClick() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
